var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompleteIndicator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#9AE6B4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.88 15.68L16.52 10.04L15.4 8.92L10.88 13.44L8.6 11.16L7.48 12.28L10.88 15.68ZM12 20C10.8933 20 9.85333 19.7899 8.88 19.3696C7.90667 18.9499 7.06 18.38 6.34 17.66C5.62 16.94 5.05013 16.0933 4.6304 15.12C4.21013 14.1467 4 13.1067 4 12C4 10.8933 4.21013 9.85333 4.6304 8.88C5.05013 7.90667 5.62 7.06 6.34 6.34C7.06 5.62 7.90667 5.04987 8.88 4.6296C9.85333 4.20987 10.8933 4 12 4C13.1067 4 14.1467 4.20987 15.12 4.6296C16.0933 5.04987 16.94 5.62 17.66 6.34C18.38 7.06 18.9499 7.90667 19.3696 8.88C19.7899 9.85333 20 10.8933 20 12C20 13.1067 19.7899 14.1467 19.3696 15.12C18.9499 16.0933 18.38 16.94 17.66 17.66C16.94 18.38 16.0933 18.9499 15.12 19.3696C14.1467 19.7899 13.1067 20 12 20Z",
    fill: "#1A202C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleteIndicator);
export default __webpack_public_path__ + "static/media/CompleteIndicator.fdc25977f636d3d33cbbd1a0d7ae5654.svg";
export { ForwardRef as ReactComponent };